import { useState, useEffect } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isChirpEnabled } from '../../../utils/isChirpEnabled';
import { trackInteraction } from '../../../tracking/tracker';
import { CLICK_DOWNLOAD } from '../../../tracking/actions';
import { ButtonWithBranding } from '../../ButtonWithBranding';
import { useGetPublicSharedLinkDownloadUrlLazyQuery } from '../../../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsPublicSharedLinkService.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const PublicViewToolbarDownloadButton = ({
  presentation,
  sharedLink,
  brandingColor,
  fetchDownloadLink,
  onDownloadCHIRP
}) => {
  const isUngatedToChirp = isChirpEnabled();
  // TODO: remove the state when we remove CHIRP gating logic
  // If we had just the CHIRP code path, we could reference chirpData?.downloadUrl directly
  const [downloadUrl, setDownloadUrl] = useState();
  const [getChirpDownloadUrl, {
    data: chirpData,
    loading: chirpLoading,
    error: chirpError
  }] = useGetPublicSharedLinkDownloadUrlLazyQuery();
  useEffect(() => {
    const id = isUngatedToChirp ? sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.id : presentation === null || presentation === void 0 ? void 0 : presentation.id;
    const accessId = isUngatedToChirp ? sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.accessId : presentation === null || presentation === void 0 ? void 0 : presentation.accessId;
    if (!id) return;
    if (isUngatedToChirp) {
      getChirpDownloadUrl({
        variables: {
          sharedLinkId: id,
          accessId: accessId
        }
      });
      setDownloadUrl(chirpData === null || chirpData === void 0 ? void 0 : chirpData.downloadUrl);
      if (chirpError) {
        console.error('CHIRP shared link download error:', chirpError);
      }
    } else {
      fetchDownloadLink(id, accessId || undefined).then(url => {
        setDownloadUrl(url);
      }).catch(err => {
        console.error('REST download error:', err);
      });
    }
  }, [isUngatedToChirp, sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.id, sharedLink === null || sharedLink === void 0 ? void 0 : sharedLink.accessId, presentation === null || presentation === void 0 ? void 0 : presentation.id, presentation === null || presentation === void 0 ? void 0 : presentation.accessId, getChirpDownloadUrl, chirpData, chirpError, fetchDownloadLink]);
  const handleDownloadClick = () => {
    trackInteraction(CLICK_DOWNLOAD);
    if (isUngatedToChirp) {
      onDownloadCHIRP();
    }
  };
  return /*#__PURE__*/_jsx(ButtonWithBranding, {
    marginInlineStart: "300",
    marginInlineEnd: "800",
    brandingColor: brandingColor,
    onClick: handleDownloadClick,
    href: downloadUrl,
    external: false,
    hideExternalLinkIcon: true,
    disabled: chirpLoading || !downloadUrl,
    "aria-label": I18n.text('a11y.downloadButton'),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "view.toolbar.download"
    })
  });
};
export default PublicViewToolbarDownloadButton;